import client from '../httpClient';

export const MerchantCreate = async (payload) => client.post(
  '/merchants',
  {
    ...payload,
  },
);
